import { Component, ViewEncapsulation, inject } from "@angular/core";
import { Observable } from "rxjs";
import { CompProductFacade } from "../services/comp-product-facade";
import { ProductFacade } from "../services/product-facade";
import { StepperComponent } from "./stepper/stepper.component";
import { ProductStepComponent } from "./product-step/product-step.component";
import { ColorStepComponent } from "./color-step/color-step.component";
import { QuantityStepComponent } from "./quantity-step/quantity-step.component";
import { CompProductContainerComponent } from "./comp-product-step/comp-product-container.component";
import { SummaryStepComponent } from "./summary-step/summary-step.component";
import { AsyncPipe } from "@angular/common";

@Component({
  selector: "app-cnp-classic",
  templateUrl: "./cnp-classic.component.html",
  imports: [
    StepperComponent,
    ProductStepComponent,
    ColorStepComponent,
    QuantityStepComponent,
    CompProductContainerComponent,
    SummaryStepComponent,
    AsyncPipe,
  ],
})
export class CNPClassicComponent {
  private productFacade = inject(ProductFacade);
  private compProdFacade = inject(CompProductFacade);

  ready$: Observable<boolean>;
  isColorStep$: Observable<boolean>;
  isQtyStep$: Observable<boolean>;
  isSummaryStep$: Observable<boolean>;
  isCompProduct$: Observable<boolean>;

  constructor() {
    this.ready$ = this.productFacade.ready$;
    this.isCompProduct$ = this.compProdFacade.showCompProduct$;
    this.isColorStep$ = this.productFacade.isColorStep$;
    this.isQtyStep$ = this.productFacade.isQtyStep$;
    this.isSummaryStep$ = this.productFacade.isSummaryStep$;
  }
}
